const ButtonRow: React.FC<ButtonRowProps> = ({ children, alignment = 'center' }) => (
    <div className={`button-row ${alignment}`}>{children}</div>
);

interface ButtonRowProps {
    alignment?: string;
}

export default ButtonRow;
